import { Component, Input } from '@angular/core';
import { AppInjector } from '../../utils/services/set-app-injector';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { CommonGadgetsService, IGadget } from '../order-gadgets/common-gadgets.service';


@Component({
  selector: 'order-details-slot-gadget',
  templateUrl: './order-details-slot-gadget.component.html',
})
export class OrderDetailsSlotGadgetComponent {

  @Input() set gadgetData(_gadget: any) {
    this.gadget = _gadget;
  }

  @Input() public gadgetIndex: number;

  @Input() public ordinalNumber: number;

  public gadget: any = {};
  public commonInfo: CommonInfoService = AppInjector.get(CommonInfoService);
  protected commonGadgetsService: CommonGadgetsService = AppInjector.get(CommonGadgetsService);

  public getGadgetPrice(): any {
    return (<IGadget>this.gadget).pricePerPiece[this.commonInfo.taxName];
  }

}
